import { useEffect } from "react";
import { useToast } from "@hiya/ui";
import { listOrders, markTabViewed } from "../../../api/orders";
import { useKitList } from "../../../hooks/useKitList";
import { KitListLayout } from "../../../components/orders/KitListLayout";
import { KitStatusBadge } from "../../../components/orders/KitStatusBadge";

const COLUMNS = ["User Name", "User Email", "Phone Number", "Order ID", "Kit ID", "Kit Type", "Status"] as const;

export function OrdersPage() {
  const { toast, showToast } = useToast();
  const kit = useKitList(listOrders);

  useEffect(() => {
    markTabViewed("orders").catch(() => showToast("Something went wrong. Please refresh the page.", "warning"));
  }, [showToast]);

  return (
    <KitListLayout
      kit={kit}
      toast={toast}
      columns={COLUMNS}
      renderRow={(item) => (
        <>
          <td className="px-4 py-3 text-sm text-text-primary">{item.user_name || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.user_email || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.phone_number || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.order_id}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.kit_code}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.kit_type}</td>
          <td className="px-4 py-3">
            <KitStatusBadge status={item.admin_status} />
          </td>
        </>
      )}
    />
  );
}
